<template>
  <div class="index">
      <div class="font">
          <div>字体1</div>
          <div>字体2</div>
      </div>
      <!-- <div class="logo"></div> -->
      <div class="index-content">
          <div class="username">
            <div class="username-title"></div>
                <input class="username-input" maxlength="10" v-model="username" placeholder="请输入昵称" type="text">
            </div>
            <div class="particular-year">
                <!-- <select v-model="year" placeholder="请选择高考年份" class="ncee-year">
                    <option value="" disabled selected>请选择高考年份</option>
                    <option v-for="(item,index) in options" :key="index" :label="item" :value="item"></option>
                </select> -->
                <el-select v-model="year" placeholder="请选择高考年份" class="ncee-year">
                    <el-option size="mini" v-for="(item,index) in options" :key="index" :label="item" :value="item"> </el-option>
                </el-select>
            </div>
            <div class="subjects">
                <div class="arts" @click="subjectsFun('arts')"></div>
                <div class="science" @click="subjectsFun('science')"></div>
            </div>
            <div class="tips" v-if="tips">
            <!-- <div class="tips"> -->
                {{tipsTitle}}
            </div>
      </div>
        <div class="popup" v-if="inerimPopup">
            <div class="popup-content">
                <div class="pencil"></div>
                <div class="loading"></div>
                <div class="progress-title">{{num}}%</div>
                <div class="progress">
                    <div class="unfinished"></div>
                    <div class="dotted-line"></div>
                    <div class="progress-cover" :style="'width:'+progressWidth+'px;'"></div>
                </div>
                <div class="interim-title">
                    <img :src="inerimTitle" alt="">
                </div>
            </div>
        </div>
        <div class="img"></div>
  </div>
</template>

<script>
import biology from '../assets/data/biology.js'  //生物
import chemistry from '../assets/data/chemistry.js'//化学
import english from '../assets/data/english.js'  //英语
import geography from '../assets/data/geography.js'  //地理
import history from '../assets/data/history.js'  //历史
import language from '../assets/data/language.js'  //语文
import mathematics from '../assets/data/mathematics.js'  //数学
import physics from '../assets/data/physics.js'   //物理
import politics from '../assets/data/politics.js'  //政治
export default {
    data(){
        return{
            progressWidth:0,
            options:['2020','2019','2018','2017','2016','2015','2014','2013','2012','2011','2010','2009','2008','2007','2006','2005','2004','2003','2002','2001','2000','1999','1998','1997','1996','1995','1994','1993','1992','1991','1990','1989','1988','1987','1986','1985'],
            year:'',
            username:'',
            tips:false,
            inerimTitle:'',
            inerimPopup:false,
            tipsTitle:'请补全信息后再答题',
            num:0,
            imgarr:[
                require('../assets/anew.png'),
                require('../assets/answer-bg.png'),
                require('../assets/arts-bg.png'),
                require('../assets/arts-title.png'),
                require('../assets/canvas-bg1.png'),
                require('../assets/canvas-bg2.png'),
                require('../assets/canvas-bg3.png'),
                require('../assets/canvas-bg4.png'),
                require('../assets/canvas-bg5.png'),
                require('../assets/canvas-bg6.png'),
                require('../assets/canvas-bg7.png'),
                require('../assets/canvas-bg8.png'),
                require('../assets/canvas-bg9.png'),
                require('../assets/canvas-bg10.png'),
                require('../assets/code.png'),
                require('../assets/home-bg.png'),
                require('../assets/home-btn.png'),
                require('../assets/img.png'),
                require('../assets/index-bg.png'),
                require('../assets/loading.png'),
                require('../assets/logo.png'),
                require('../assets/next-topic.png'),
                require('../assets/on-topic.png'),
                require('../assets/pencil.png'),
                require('../assets/popup-b.png'),
                require('../assets/save-bg.png'),
                require('../assets/science-bg.png'),
                require('../assets/science-title.png'),
                require('../assets/seal.png'),
                require('../assets/tell.png'),
                require('../assets/tips.png'),
                require('../assets/title-bg.png'),
                require('../assets/volunteer.png'),
            ],
            questionList:[]
        }
    },
    created(){
        this.share()
        if(window.localStorage.getItem('kkusername')){
            this.username = window.localStorage.getItem('kkusername')
        }
    },
    methods:{
        share(){
                    // 微信分享
            window.wx.ready(() => {
                // 分享好友
                window.wx.updateAppMessageShareData({
                title: "测测你的高考剩余值", // 分享标题
                desc: "如果重返高考考场，你到底还能拿多少分呢？", // 分享描述
                link: "https://h5case3.xiaoxxx.cn/202105/quark-answer2/index.html", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
                    "https://h5case3.xiaoxxx.cn/202105/quark-answer/src/assets/fx.jpg", // 分享图标
                success: function () {
                    // 设置成功
                    // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数','1','1']);
                },
                });
                // 分享朋友圈
                window.wx.updateTimelineShareData({
                title: "测测你的高考剩余值", // 分享标题
                link: "https://h5case3.xiaoxxx.cn/202105/quark-answer2/index.html", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
                    "https://h5case3.xiaoxxx.cn/202105/quark-answer/src/assets/fx.jpg", // 分享图标
                success: function () {
                    // 设置成功
                    // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数','1','1']);
                },
                });
            });
        },
        subjectsFun(str){
            
            if(this.year==''||this.username==""){
                this.tipsTitle='请补全信息后再答题'
                this.tips = true
                setTimeout(() => {
                    this.tips = false
                }, 1000);
                return false
            }
            // window.fetch('https://h5api.xiaoxxx.cn/h5/commonKey/sensitiveWord', {
            //     method: 'POST',
            //     body: {content:this.username}
            // }).then(res => {
            //     return res.json()
            // }).then(res => {
            //     console.log(res)
                // if(res.data.words.length==0){
                    window.localStorage.setItem('kkusername',this.username)
                    if(str=='arts'){
                        this.inerimTitle = require('../assets/arts-title.png')
                        language.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        mathematics.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        english.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        geography.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        history.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        politics.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        // this.$router.push({path:'/interim',query:{'subjects':'arts'}})
                    }else if(str=='science'){
                        language.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        mathematics.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        english.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        biology.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        chemistry.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        physics.map((v)=>{
                            if(v.year==this.year){
                                return this.questionList.push(v)
                            }
                        })
                        this.inerimTitle = require('../assets/science-title.png')
                        // this.$router.push({path:'/interim',query:{'subjects':'science'}})
                    }
                    this.inerimPopup = true
                    this.loadImages(this.imgarr)
                    
                // }else{
                //     this.tipsTitle='内容含有敏感词请更换'
                //     this.tips = true
                //     setTimeout(() => {
                //         this.tips = false
                //     }, 1000);
                // }
            // })
            var script = document.createElement("script")
            script.type = 'text/javascript'
            script.src = 'https://api.xiaoxxx.com/sensitive?callback=backfn&word=' + this.username
            document.head.appendChild(script)
            document.head.removeChild(script)
            window.backfn = (e) => {
                if(e.code==0){
                    if(e.data.words.length==0){
                        window.localStorage.setItem('kkusername',this.username)
                        if(str=='arts'){
                            this.inerimTitle = require('../assets/arts-title.png')
                            language.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            mathematics.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            english.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            geography.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            history.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            politics.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            // this.$router.push({path:'/interim',query:{'subjects':'arts'}})
                        }else if(str=='science'){
                            language.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            mathematics.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            english.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            biology.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            chemistry.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            physics.map((v)=>{
                                if(v.year==this.year){
                                    return this.questionList.push(v)
                                }
                            })
                            this.inerimTitle = require('../assets/science-title.png')
                            // this.$router.push({path:'/interim',query:{'subjects':'science'}})
                        }
                        this.inerimPopup = true
                        this.loadImages(this.imgarr)
                        
                    }else{
                        this.tipsTitle='内容含有敏感词请更换'
                        this.tips = true
                        setTimeout(() => {
                            this.tips = false
                        }, 1000);
                    }
                }
            }
        },
        loadImages(imgarr){
            var that = this
            var updatanum = 0
            for (var i = 0; i < imgarr.length; i++) {
            var img = new Image();
            img.onload = function () {
                updatanum = updatanum + 1
                that.num = Math.floor(((imgarr.length - (imgarr.length - updatanum)) / imgarr.length) * 100)
                that.progressWidth = that.num * 2.74
                if (that.num == 100) {
                    setTimeout(() => {
                        that.$router.push({path:'/answer',query:{questionList:JSON.stringify(that.questionList)}})
                    }, 2000);
                }
            };
            img.onerror = function () {
                // console.log("第" + i + "个img加载error")
            };
            img.src = imgarr[i]
            }
        }
    }
}
</script>

<style scoped>
.font{
    position: absolute;
    left: -500px;
    top: -50px;
}
.font div:nth-child(1){
    font-family: siyuan;
}
.font div:nth-child(2){
    font-family: huakang;
}
.img{
    width: 2.07rem;
    height: 1.66rem;
    background: url('../assets/img.png') no-repeat center;
    background-size: cover;
    position: fixed;
    right: 0;
    bottom: 0;
}
.logo{
    width: 1.57rem;
    height: 0.48rem;
    background: url('../assets/logo.png') no-repeat center;
    background-size: cover;
    position: absolute;
    left: 0.5rem;
    top: 0.3rem;
}
.popup-content{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 7rem;
}
.progress-cover{
    height: 0.2rem;
    background-color: #d7783f;
    border-radius: 0.1rem;
    position: absolute;
    left: 0.12rem;
    top: 0;
    bottom: 0;
    margin: auto;
    /* transform: translateY(-50%); */
    transition: all 1s;
}
.dotted-line{
    width: 274px;
    height: 1px;
    border-bottom: dashed 1px #dd7a40;
    position: absolute;
    left: 0;
    top: 0;
    margin: auto;
    bottom: 0;
    right: 0;
    /* transform: translate(-50%,-50%); */
}
.unfinished{
    width: 274px;
    height: 0.2rem;
    background-color: #dfdfea;
    border-radius: 0.1rem;
    position: absolute;
    left:0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    /* transform: translate(-50%,-50%); */
}
.progress-title{
    font-size: 0.3rem;
    color: #d7783f;
    /* position: absolute; */
    /* left: 50%; */
    /* transform: translateX(-50%); */
    /* top: calc(50% - 1.1rem); */
    font-weight: bold;
}
.progress{
    width: 286px;
    height: 0.46rem;
    border-radius: 0.2rem;
    border: solid 2px #1e1e4a;
    position: relative;
    margin: 0.28rem auto 1.02rem;
    /* left: 50%; */
    /* transform: translateX(-50%); */
    /* top: calc(50% - 0.5rem); */
}
.pencil{
    width: 1.04rem;
    height: 0.73rem;
    background: url('../assets/pencil.png') no-repeat center;
    background-size: cover;
    margin: 0 auto;
    /* position: absolute; */
    /* left: 50%; */
    /* transform: translateX(-50%); */
    /* top: calc(50% - 3rem); */
}
.loading{
    width: 1.99rem;
    height: 0.47rem;
    background: url('../assets/loading.png') no-repeat center;
    background-size: cover;
    margin: 0.4rem auto 0.25rem;
    /* position: absolute; */
    /* left: 50%; */
    /* transform: translateX(-50%); */
    /* top: calc(50% - 1.8rem); */
}
.popup{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    z-index: 10;
}
.interim-title{
    /* position: absolute; */
    /* left: 50%; */
    /* top: calc(50% + 1rem); */
    /* transform: translate(-50%,-50%); */
    font-size: 0.3rem;
    white-space: nowrap;
}
.interim-title img{
    width: 4.84rem;
}
.index{
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    background: url('../assets/index-bg.png') no-repeat center;
    background-size: cover;
}
.index-content{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 5rem;
}
.username{
    /* display: flex; */
    color: #000000;
    margin-left: 1.6rem;
    /* position: absolute; */
    /* left: 50%; */
    /* transform: translateX(-50%); */
    /* top: calc(50% - 2.5rem); */
    white-space: nowrap;
    width: 4.5rem;
    align-items: center;
}
.username:after{
    content:"";
    display:block;
    clear:both;
    height:0;
    overflew:hidden;
}
.username-title{
    width: 0.84rem;
    height: 0.36rem;
    margin-right: 0.2rem;
    background: url('../assets/name.png') no-repeat center;
    background-size: cover;
    margin-top: 0.1rem;
    float: left;
}
.username-input{
    border: none;
    border: solid 1px black;
    outline: none;
    text-align: center;
    width: 2.21rem;
    border-radius: 0.04rem;
    font-size: 0.32rem;
    height: 0.56rem;
    float: left;
}
.ncee-year{
    width: 5.2rem;
}
.particular-year{
    /* position: absolute; */
    /* left: 50%; */
    /* transform: translateX(-50%); */
    /* top: calc(50% - 1.7rem); */
    margin-bottom: 1.54rem;
}
.subjects{
    margin: 0 auto;
    /* justify-content: center; */
    /* position: absolute; */
    /* left: 50%; */
    /* transform: translateX(-50%); */
    /* top: calc(50% + 1rem); */
    /* display: flex; */
    display: inline-block;
    /* align-items: center; */
}
.subjects:after{
    content:"";
    display:block;
    clear:both;
    height:0;
    overflew:hidden;
}
.arts{
    height: 0.99rem;
    background: url('../assets/arts-bg.png');
    background-size: cover;
    width: 2.2rem;
    float: left;
}
.science{
    height: 0.99rem;
    background: url('../assets/science-bg.png');
    background-size: cover;
    width: 2.2rem;
    margin-left: 0.73rem;
    float: left;
}
.tips{
    background: url('../assets/tips.png') no-repeat left center;
    background-size: 8%;
    /* position: fixed; */
    /* left: 50%; */
    /* top: calc(50% + 3.5rem); */
    /* transform: translateX(-50%); */
    width: 4rem;
    height: 0.6rem;
    border-radius: 0.1rem;
    /* background-color: rgba(0, 0, 0, 0.5); */
    text-align: center;
    line-height: 0.6rem;
    font-size: 0.32rem;
    color: #04072a;
    font-family: siyuan;
    margin: 1.57rem auto 0;
}
</style>